<template>
    <div class="text-center">
      <v-menu offset-y content-class="tbl-action-dropdown">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
             v-bind="attrs"
            v-on="on"
            class="action-button"
          >
            Action
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list v-if="!this.timestampDeleted">
          <v-list-item :disabled="!model.read"  @click="manageRead" class="read-list-items" v-if="this.rolePermission[`${this.model.permissionKeys.read}`].isAllowed">
            <v-list-item-title>View</v-list-item-title>
          </v-list-item>
          <v-list-item :disabled="!model.edit" @click="manageEdit" class="edit-list-items" v-if="this.rolePermission[`${this.model.permissionKeys.edit}`].isAllowed">
            <v-list-item-title>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item :disabled="!model.delete" @click="manageDelete" class="delete-list-items" v-if="this.rolePermission[`${this.model.permissionKeys.delete}`].isAllowed">
            <v-list-item-title>Delete</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-list v-else>
          <v-list-item @click="manangeRestore" v-if="this.rolePermission[`${this.model.permissionKeys.restore}`].isAllowed">
            <v-list-item-title>Restore</v-list-item-title>
          </v-list-item>
          <v-list-item @click="manageHardDelete" v-if="this.rolePermission[`${this.model.permissionKeys.forceDelete}`].isAllowed">
            <v-list-item-title>Delete Hard</v-list-item-title>
          </v-list-item>
        </v-list>

      </v-menu>
    </div>
  </template>

<script>

import Api from "@/objects/api";
import Model from "@/objects/model";
import Service from "@/objects/service";
import { mapState } from "vuex";

export default {
  name: "BreadTabulatorActionButton",

  computed: mapState({
    auth: (state) => state.auth.data,
    services: (state) => state.service.data.services,
    rolePermission: (state) => state.rolePermission.data,
  }),

  props: {
    cellData: {},
    cellValue: {},
    cellRowData: {},
    serviceKey: {},
    modelKey: {},
    modelId: {},
  },

  data: () => ({
    model: new Model(),
    service: new Service(),
    api: new Api(),
    manageDetachButton: null,
    isTeamAdmin: false,
    adminCount: 0,
    viewId: null,
    timestampDeleted: null,
  }),

  created() {
    this.model.getByKey(this.modelKey);
    this.viewId = this.$route.query.viewId;
    this.timestampDeleted = this.cellRowData.timestampDeleted;

  },

  mounted() {
    //
  },

  methods: {
    manageRead(){
        this.$router.push({
        name: 'PageServiceModelBreadTabulatorRead',
        params: {
            serviceKey: this.serviceKey,
            modelKey: this.modelKey,
            modelId: this.modelId,
        },
        query: {
            viewId: this.viewId,
          },
      });
    },

    /**
     * Edit opens over the listing where the page hosts a dialog, and routes to
     * the edit page where it doesn't (the legacy dev-model Tabulator pages).
     *
     * This component is mounted imperatively by a model's column formatter, so
     * it has no parent to $emit to — the store is the only channel it shares
     * with the page it is drawn on. See store/modules/modelEditDialog.js.
     */
    manageEdit(){
        const dialog = this.$store.state.modelEditDialog;
        if (dialog && dialog.data.hostCount > 0) {
          this.$store.dispatch("requestModelEdit", {
            serviceKey: this.serviceKey,
            modelKey: this.modelKey,
            modelId: this.modelId,
          });
          return;
        }

        this.$router.push({
        name: 'PageServiceModelBreadTabulatorEdit',
        params: {
            serviceKey: this.serviceKey,
            modelKey: this.modelKey,
            modelId: this.modelId,
        },
      });
    },

    /**
     * Same arrangement as manageEdit above: confirm over the listing where the
     * page hosts a dialog, route to the delete page where it doesn't. The row
     * goes along so the dialog can name the record without a second read.
     * See store/modules/modelDeleteDialog.js.
     */
    manageDelete(){
        const dialog = this.$store.state.modelDeleteDialog;
        if (dialog && dialog.data.hostCount > 0) {
          this.$store.dispatch("requestModelDelete", {
            serviceKey: this.serviceKey,
            modelKey: this.modelKey,
            modelId: this.modelId,
            row: this.cellRowData,
          });
          return;
        }

        this.$router.push({
        name: 'PageServiceModelBreadTabulatorDelete',
        params: {
            serviceKey: this.serviceKey,
            modelKey: this.modelKey,
            modelId: this.modelId,
        },
      });
    },
    manangeRestore(){
        this.$router.push({
            name: "PageServiceModelBreadTabulatorRestore",
            params: {
            serviceKey: this.serviceKey,
            modelKey: this.modelKey,
            modelId: this.modelId,
            },
        });
    },
    manageHardDelete(){
        this.$router.push({
              name: "PageServiceModelBreadTabulatorDeleteHard",
              params: {
                serviceKey: this.serviceKey,
                modelKey: this.modelKey,
                modelId: this.modelId,
              },
            });
    },

  }
};
</script>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .tbl-action-dropdown {
  border: 1px solid var(--app-border) !important;
}

.dark-mode .tbl-action-dropdown .v-list {
  background: var(--app-card) !important;
}

.dark-mode .tbl-action-dropdown .v-list-item:hover {
  background: var(--app-accent-soft) !important;
}

.dark-mode .tbl-action-dropdown .v-list-item__title {
  color: var(--app-text) !important;
}

.dark-mode .tbl-action-dropdown .delete-list-items:hover {
  background: var(--app-danger-bg) !important;
}

/* >>> end auto-dark <<< */

/* Action dropdown (rendered outside component, must be unscoped) */
.tbl-action-dropdown {
  border-radius: 10px !important;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e2e8f0 !important;
  min-width: 160px !important;
  overflow: hidden !important;
}

.tbl-action-dropdown .v-list {
  padding: 4px !important;
  background: #fff !important;
}

.tbl-action-dropdown .v-list-item {
  min-height: 36px !important;
  border-radius: 6px !important;
  margin: 1px 0 !important;
  padding: 0 12px !important;
  transition: background 0.1s ease;
}

.tbl-action-dropdown .v-list-item:hover {
  background: #f0f9ff !important;
}

.tbl-action-dropdown .v-list-item--disabled {
  opacity: 0.4 !important;
}

.tbl-action-dropdown .v-list-item__title {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.82rem !important;
  font-weight: 500 !important;
  color: #334155 !important;
}

.tbl-action-dropdown .v-list-item:hover .v-list-item__title {
  color: #0ea5e9 !important;
}

/* Delete item gets red hover */
.tbl-action-dropdown .delete-list-items:hover {
  background: #fef2f2 !important;
}

.tbl-action-dropdown .delete-list-items:hover .v-list-item__title {
  color: #ef4444 !important;
}

/* Dark mode */
.dark-mode .tbl-action-dropdown {
  border-color: var(--app-border) !important;
  box-shadow: 0 6px 24px var(--app-shadow-mid) !important;
}

.dark-mode .tbl-action-dropdown .v-list {
  background: var(--app-page) !important;
}

.dark-mode .tbl-action-dropdown .v-list-item:hover {
  background: var(--app-card) !important;
}

.dark-mode .tbl-action-dropdown .v-list-item__title {
  color: var(--app-neutral-fg) !important;
}

.dark-mode .tbl-action-dropdown .v-list-item:hover .v-list-item__title {
  color: var(--app-accent) !important;
}

.dark-mode .tbl-action-dropdown .delete-list-items:hover {
  background: var(--app-danger-bg) !important;
}

.dark-mode .tbl-action-dropdown .delete-list-items:hover .v-list-item__title {
  color: var(--app-danger-fg) !important;
}
</style>
